/**
 * Deep link desktop: /professor/turmas/:id → lista com modal aberto.
 */
import { useState, useEffect } from 'react';
import { useParams, Navigate } from 'react-router-dom';

function useIsMobile(bp = 768) {
  const [m, setM] = useState(() =>
    typeof window !== 'undefined' ? window.innerWidth < bp : false,
  );
  useEffect(() => {
    const h = () => setM(window.innerWidth < bp);
    window.addEventListener('resize', h);
    return () => window.removeEventListener('resize', h);
  }, [bp]);
  return m;
}

export function ProfessorTurmaRedirectPage() {
  const { id } = useParams<{ id: string }>();
  const isMobile = useIsMobile();

  if (!id) {
    return <Navigate to="/professor/turmas" replace />;
  }

  if (isMobile) {
    return <Navigate to="/professor/turmas" replace state={{ turmaId: id }} />;
  }

  return <Navigate to="/professor/turmas" replace state={{ turmaId: id }} />;
}
